import React, { useContext } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import Home from "./page/Home/Home.jsx";
import Admin from "./page/Admin/Admin.jsx";
import Order from "./page/Order/Order.jsx";
import ErrorPage from "./page/Error/Error.jsx";
import Login from "./page/Login/Login.jsx";
import Agents from "./page/Agents/Agents.jsx";
import NewAgent from "./page/newAgent/NewAgent.jsx";
import { Context } from "./context/Context";
import Stats from "./page/Stats/Stats";
import History from "./page/History/History";
import NewReservation from "./page/newReservation/NewReservation";
const App = () => {
  const { user } = useContext(Context);
  return (
    <Router basename="/parking-pyrzowice-art-lot">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path={`/admin`}>
          {user ? <Admin /> : <Redirect to="/login" />}
        </Route>
        <Route path={`/agent`}>
          {user ? <Admin /> : <Redirect to="/login" />}
        </Route>
        <Route path={`/agentslist`}>
          {user?.role === "admin" ? <Agents /> : <Redirect to="/error" />}
        </Route>
        <Route path={`/agents/new`}>
          {user?.role === "admin" ? <NewAgent /> : <Redirect to="/error" />}
        </Route>
        <Route path={`/dashboard`}>
          {user?.role === "admin" ? <Stats /> : <Redirect to="/error" />}
        </Route>
        <Route path={`/history`}>
          {user ? <History /> : <Redirect to="/login" />}
        </Route>
        <Route path={`/reservation/new`}>
          {user ? <NewReservation /> : <Redirect to="/login" />}
        </Route>
        <Route path="/login" component={Login} />
        <Route path="/order" component={Order} />
        <Route path="*" component={ErrorPage} />
      </Switch>
    </Router>
  );
};

export default App;
